import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const AiInsightTypeSchema = z.enum([
  'REVENUE_OCCUPANCY',
  'STAFF',
  'ALERTS_FLAGS',
]);

export const GetAiInsightRequestDtoSchema = z.object({
  facilityId: z.number(),
  type: AiInsightTypeSchema,
});

export const AiInsightResponseDtoSchema = z.object({
  summary: z.string(),
  recommendation: z.string(),
  month: z.string(),
  generatedAt: z.string(),
});

export type AiInsightType = z.infer<typeof AiInsightTypeSchema>;
export type GetAiInsightRequestDto = z.infer<
  typeof GetAiInsightRequestDtoSchema
>;
export type AiInsightResponseDto = z.infer<typeof AiInsightResponseDtoSchema>;

export const getAiInsight = async (
  params: GetAiInsightRequestDto,
  config?: AxiosRequestConfig<GetAiInsightRequestDto>
) => {
  const { facilityId, type } = params;

  return api
    .get(`/market-intelligence/facilities/${facilityId}/ai-insight`, {
      params: { type },
      ...config,
    })
    .then(responseContract(AiInsightResponseDtoSchema));
};
